import { IRootState } from '../../../store'
import { IPulsaraState } from '../store/pulsara.types'

export const getPulsaraSelector = (state: IRootState): IPulsaraState => state.pulsara

export const getSelectedAttachment = (state: IRootState) => state.pulsara.selectedAttachment

export const getPulsaraCurrentStep = (state: IRootState) => state.pulsara.currentStep
export const getPulsaraCurrentSubStep = (state: IRootState) => state.pulsara.currentSubStep
export const getSelectedDateRange = (state: IRootState) => state.pulsara.selectedDateRange
export const getPulsaraLoading = (state: IRootState) => state.pulsara.loading

export const getImportSelections = (state: IRootState) => state.pulsara.importSelections
export const getImportSelectionsPatientDemographics = (state: IRootState) =>
  state.pulsara.importSelections.patient?.patientDemographics
export const getImportSelectionsSelectedVitals = (state: IRootState) => state.pulsara.importSelections.selectedVitals
export const getImportSelectionsSelectedLabs = (state: IRootState) => state.pulsara.importSelections.selectedLabs
export const getImportSelectionsSelectedAttachments = (state: IRootState) =>
  state.pulsara.importSelections.selectedAttachments

export const getPulsaraDetails = (state: IRootState) => state.pulsara.pulsaraDetails
export const getPulsaraDetailsCaseType = (state: IRootState) => state.pulsara.pulsaraDetails.caseType
export const getPulsaraDetailsCreatedAt = (state: IRootState) => state.pulsara.pulsaraDetails.createdAt
export const getPulsaraDetailsPatientDemographics = (state: IRootState) =>
  state.pulsara.pulsaraDetails.patient?.patientDemographics
export const getPulsaraDetailsVitals = (state: IRootState) => state.pulsara.pulsaraDetails.vitals
export const getPulsaraDetailsLabs = (state: IRootState) => state.pulsara.pulsaraDetails.labs
export const getPulsaraDetailsAttachmentList = (state: IRootState) => state.pulsara.pulsaraDetails.attachmentList
export const getPulsaraDetailsAttachments = (state: IRootState) => state.pulsara.pulsaraDetails.attachments
